import { render, staticRenderFns } from "./EncuentroNacional2026Socio.vue?vue&type=template&id=54eca5d8&"
import script from "./EncuentroNacional2026Socio.vue?vue&type=script&lang=js&"
export * from "./EncuentroNacional2026Socio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports